import React, { useState } from 'react';
import './TaxiSingle.css';

import { Button, PageTitle, Comments } from '../../../components';
import { calculateAverageRating, countCommentsAndReplies, renderIcon } from '../../../utils';

import { FaStar, FaCheck, FaTaxi } from 'react-icons/fa';

import { useLocation } from 'react-router-dom'; 
import ImageGallery from 'react-image-gallery';



const TaxiSingle = () => {

  // State for managing the selected information tab
  const [selectedOption, setSelectedOption] = useState('description');

  // Get taxi data from the location state
  const location = useLocation();  
  const taxi = location.state;  

  // Extract taxi details and reviews
  const specs = taxi.details;
  const taxiReviews = taxi.comments;

  // Calculate the total number of comments and replies for the product
  let totalCommentsAndReplies = 0;
  if (taxiReviews) {
    totalCommentsAndReplies = countCommentsAndReplies(taxiReviews);
  }
  
  // Calculate the average rating for the Taxi
  const averageRating = calculateAverageRating(taxi);

  // Handle option change for the Taxi information tabs
  const handleOptionChange = (option) => {
    setSelectedOption(option);
  }; 

  // Handle form submission for adding a review/comment
  const handleSubmit = (event) => {

    event.preventDefault(); // Prevent the default form submission behavior

    const formData = new FormData(event.target);
    const values = Object.fromEntries(formData.entries());

    // Check if all input fields are filled
    const isFormValid = Object.values(values).every((value) => value.trim() !== '');

    if (isFormValid) {
      // Reset the form fields
      event.target.reset();
    }

  };

  // Function to split the details into groups of 2
  const splitIntoChunks = (arr, chunkSize) => {
    const result = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      result.push(arr.slice(i, i + chunkSize));
    }
    return result;
  };

  // Create an array of images for the image gallery
  const image = [  
    {
      original: taxi.gallery.image1,
      thumbnail:  taxi.gallery.image1,
    },
    {
      original: taxi.gallery.image2,
      thumbnail:  taxi.gallery.image2,
    },
    {
      original: taxi.gallery.image3,
      thumbnail:  taxi.gallery.image3,
    },
    {
      original: taxi.gallery.image4,
      thumbnail:  taxi.gallery.image4,
    },
  ];

  // Convert taxi details into an array of key-value pairs and split them into groups of 2
  const detailEntries = Object.entries(specs);
  const detailChunks = splitIntoChunks(detailEntries, 2); // Split into chunks of 2

  return (
    <>
      {/* Page title */}
      <PageTitle title={'Taxi single'} page={'Taxi single'} />

      {/* Taxi Single Section */}
      <section className='taxi-single product-single'>

        {/* Taxi Description */}
        <div className='taxi-description product-des'>
 
          <div className='product-container'>

            {/* Taxi Image Gallery */}
            <div className='image'>
              <ImageGallery items={image} /> 
            </div>

            {/* Taxi Details & Info */}
            <div className='content'>
              <div className='text'>

                {/* Taxi Intro */}
                <div className='taxi-intro'>
                  
                  <div>
                    <h2>{taxi.name}</h2> {/* Taxi Name */}
                    <div className='rating'>  {/* Taxi Rating */}
                      <div className='icon'>            
                        <FaStar /> <FaStar /> <FaStar /> <FaStar /> <FaStar /> 
                      </div> 
                      {/* Render average rating and comment count */}
                      {taxiReviews.length > 0 ? (
                        <h5>{averageRating} ({taxiReviews.length})</h5>
                      ) : (
                        <h5>Not rated</h5>
                      )}
                    </div> 
                  </div>

                  <div className='price'>${taxi.baseFare}<span>/base fare</span></div> {/* Taxi Base Fare */}

                </div>

                <div className='box'> 
                  <p>Economy Taxi is a budget-friendly option for daily commutes and short trips within the city. It provides a reliable and economical means of transportation with a focus on comfort and efficiency. Our Economy Taxi fleet is well-maintained and regularly inspected to ensure a smooth and safe ride. With affordable rates and excellent service, it’s the perfect choice for anyone seeking a cost-effective travel solution.</p>
                  <Button link={'Booking'} title={'Book Ride'} />
                </div>

                {/* Taxi Specifications */}
                <div className="details">
                  {detailChunks.map((chunk, chunkIndex) => (
                    <div className="detail-group" key={chunkIndex}>
                      {chunk.map(([key, value], index) => (
                        <div className="detail-item" key={index}>

                          <div className="detail-intro">
                            <div className='icon'>{renderIcon(key)}</div>
                            <strong>{key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())}</strong>
                          </div>
                          <span>{value}</span>
                          
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
                    
              </div>
            </div>

          </div>

          {/* Taxi Information Tabs */}
          <div className='product-info taxi-info page-info'>

            {/* Product Information Tab */}
            <div className="taxi-info-tabs tab-buttons">

              {/* Description Tab */}
              <button
                type="button"
                className={`button ${selectedOption === 'description' ? 'active' : ''}`}
                onClick={() => handleOptionChange('description')}>
                description
              </button>

              {/* Additional Information Tab */}
              <button
                type="button"
                className={`button ${selectedOption === 'additionalInfo' ? 'active' : ''}`}
                onClick={() => handleOptionChange('additionalInfo')}>
                Additional Information
              </button>

              {/* Reviews Tab */}
              <button
                type="button"
                className={`button ${selectedOption === 'reviews' ? 'active' : ''}`}
                onClick={() => handleOptionChange('reviews')}>
                reviews ({totalCommentsAndReplies})
              </button>

            </div>

            {/* Description Container */}
            {selectedOption === 'description' && (
              <div className="description">

                <p>{taxi.description}</p>

                <div className='sub-section'>
                  <h3 className='sub-heading'>Vehicle List:</h3>
                  <p>Our {taxi.name} service includes the following models:</p>
                  <ul>
                    {taxi.vehicleList.map((vehicle, index) => (
                      <li key={index}><FaTaxi className='icon' />{vehicle}</li>
                    ))}
                  </ul>
                </div>

              </div>
            )}

            {/* Additional Information Container */}
            {selectedOption === 'additionalInfo' && (

              <div className='features-container sub-section'>
                <ul>
                  {taxi.additionalInfo.slice(0, 5).map((feature, index) => (
                    <li key={index}><FaCheck className='icon' />{feature}</li>
                  ))}
                </ul>
                <ul>
                  {taxi.additionalInfo.slice(5).map((feature, index) => (
                    <li key={index + 5}><FaCheck className='icon' />{feature}</li>
                  ))}
                </ul>
              </div>

            )}

            {/* Reviews Container */}
            {selectedOption === 'reviews' && (
              <div className='reviews'>
                {/* Reviews */}
                <Comments comments={taxiReviews} />
                <div className='leave-reply'>
                  {/* Leave a Comment Form */}
                  <form className='form' onSubmit={handleSubmit}>
                    <h2>leave a comment</h2>  
                    <div className='input-box'>
                      <input type="text" name="name" className='box' id="name" placeholder="name" required />
                      <input type="email" name="email" className='box' id="email" placeholder="email" required />
                    </div>
                    <textarea cols="30" rows="10" name="comment" className='box' id="comment" placeholder="comment"></textarea>
                    <button type="submit" name="submit" id="submit" className='btn'>submit</button>
                  </form>
                </div>
              </div>
            )}

          </div>

        </div>

      </section>
    </>
  )
}

export default TaxiSingle;